import 'view/css/e-invoice.css';

import { useEffect, useState } from 'react';

import API from 'service/api';

import PopMessage from 'component/pop-msg/PopMessage';

import EReceiptSelectionFilter from './EReceiptSelectionFilter';
import EReceiptSelection from './EReceiptSelection';

const flattenPayments = (payments) =>
{
  let arr = [];
  if (payments) for (let company of Object.keys(payments))
  {
    let l2_items = payments[company];
    for (let l3_item of l2_items)
    {
      // skip license of * : will not be able to get the vehicle location
      if (l3_item.license === '*') {
        continue;
      }

      if (l3_item.is_email
        ||l3_item.is_whatsapp)
      { arr.push(l3_item); }
    }
  }
  return arr;
}

const getDtoMapper = flag => {
  return x => {
    let {
      company, uid, license, first_license: cd_license,
      id, transfer_dtm, loc_key,
      cust_name, loc_psn, pay_for,
      ref_code, amount,
    } = x;

    let dto = {
      cd_license,  // get the first plate number
      license,     // list of plate numbers in string
      company, uid,
      id, transfer_dtm, loc_key,
      cust_name, loc_psn, pay_for,
      ref_code, amount,
    };

    if (flag)
    {
      dto[flag] = true;
    } else {
      dto.is_whatsapp = x.is_whatsapp;
      dto.is_email = x.is_email;
    }

    return dto;
  };
}

const EReceiptModal = ({payments, addOns}) =>
{
  const [disabled, setDisabled] = useState(false);
  const [items, setItems] = useState([]);

  const [filter, setFilter] = useState({
    company: '',
    district: '', location: '',
    cd_license: '',
    media_type: '',
  })

  useEffect(() => {
    setItems(flattenPayments(payments));
  }, [payments]);

  const sendAllSelected = () => {
    const selectedItems = items
      .filter(i => i.selected);

    if (selectedItems.length <= 0) {
      PopMessage.show('請先選擇要寄出的賬單。', '訊息', 'danger');
      return false;
    }

    onSend(selectedItems).then(() => {
      selectedItems.forEach(x => x.selected = false);
      setItems([...items]);
    }).then(() => {
      setTimeout(() => setDisabled(false), 10000); // 10s
    });
  }

  const onSend = (selectedItems, flag) =>
  {
    const items = selectedItems.map(getDtoMapper(flag));
    const dto = { addOns, items }

    const promise = new Promise((resolve, reject) =>
    {
      setTimeout(() => {
        API.sendReceipt(dto).then(resp => {
          if (resp.success) {
            PopMessage.show('已排程寄單工作。', '成功', 'success');
          } else {
            PopMessage.show('寄發電子收據時出現錯誤。', '錯誤', 'danger');
          }
        });
        resolve();
      });
    });

    return promise;
  }

  return (<div className="e-invoice-modal">
    <EReceiptSelectionFilter onChange={setFilter} />
    <EReceiptSelection items={items} filter={filter} onSend={onSend} />
    <div className="btn-group">
      <button className="btn btn-small red" disabled={disabled}
        onClick={sendAllSelected}>發送已選取</button>
    </div>
  </div>);
}

export default EReceiptModal;
